function wrap(element, wrapper) {
  element.parentNode.insertBefore(wrapper, element);
  wrapper.appendChild(element);
};

function unwrap(element) {
  // get the element's parent node
  var parent = element.parentNode;

  // move all children out of the element
  while (element.firstChild) parent.insertBefore(element.firstChild, element);

  // remove the empty element
  parent.removeChild(element);
}

export default {
  bind: function (el, bindings, vnode) {
  },
  inserted: function(el, bindings) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(bindings.value, 'text/html');

    // Wysiwygから渡されたNodeListのテーブルのみをWrap
    [].forEach.call(htmlDoc.querySelectorAll('table'), table => {
      let tableWrapElement = document.createElement('div');
      tableWrapElement.setAttribute('class', 'c-wysiwyg__module c-wysiwyg__table');

      wrap(table, tableWrapElement);
    });

    // Wysiwygから渡されたNodeListのテーブルのみをWrap
    [].forEach.call(htmlDoc.body.childNodes, dom => {
      el.appendChild(dom);
    });

    unwrap(el);
  },
  update: function (el, bindings) {
  },
  unbind: function (el, bindings) {
  }
}


// WEBPACK FOOTER //
// ./src/plugins/vue-whtml/directive.js